module.exports = __webpack_public_path__ + "static/media/edit-permission-overview.1dff12d4.png";